import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useGetSocialAnalyticsQuery } from "../../../../redux/apiSlice";
import { errorMessage } from "../../../util/Helpers";
import cogoToast from "cogo-toast";

export const SocialAnalytics = () => {
  const { data, isLoading, error } = useGetSocialAnalyticsQuery();

  if (error) {
    cogoToast.error(errorMessage(error));
  }

  return (
    <Card>
      <CardHeader title="Social Analytics" />
      <CardBody>
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center">
            <div className="spinner spinner-primary spinner-lg mr-15"></div>
          </div>
        ) : (
          <div className="row">
            <div className="col-lg-4">
              <div className="card card-custom bg-light-primary gutter-b">
                <div className="card-body">
                  <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                    <i className="flaticon-users-1 text-primary font-size-h1"></i>
                  </span>
                  <div className="text-dark font-weight-bolder font-size-h2 mt-3">
                    {data?.data?.totalUsers || data?.data?.total_users || 0}
                  </div>
                  <div className="text-muted font-weight-bold font-size-lg mt-1">
                    Total Users
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card card-custom bg-light-success gutter-b">
                <div className="card-body">
                  <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                    <i className="flaticon-star text-success font-size-h1"></i>
                  </span>
                  <div className="text-dark font-weight-bolder font-size-h2 mt-3">
                    {data?.data?.totalPowerUsers || data?.data?.total_power_users || 0}
                  </div>
                  <div className="text-muted font-weight-bold font-size-lg mt-1">
                    Total Power Users
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card card-custom bg-light-info gutter-b">
                <div className="card-body">
                  <span className="svg-icon svg-icon-3x svg-icon-info d-block my-2">
                    <i className="flaticon-user text-info font-size-h1"></i>
                  </span>
                  <div className="text-dark font-weight-bolder font-size-h2 mt-3">
                    {data?.data?.totalRegularUsers || data?.data?.total_regular_users || 0}
                  </div>
                  <div className="text-muted font-weight-bold font-size-lg mt-1">
                    Total Regular Users
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};
